// extracted by mini-css-extract-plugin
module.exports = {"button":"PaginationButtons_button__2UWtw","status":"PaginationButtons_status__3lErC","prev":"PaginationButtons_prev__XS0cR","next":"PaginationButtons_next__1-vbX"};